import { render, staticRenderFns } from "./registerDetails.vue?vue&type=template&id=052597c0&scoped=true&"
import script from "./registerDetails.vue?vue&type=script&lang=js&"
export * from "./registerDetails.vue?vue&type=script&lang=js&"
import style0 from "./registerDetails.vue?vue&type=style&index=0&id=052597c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052597c0",
  null
  
)

export default component.exports